import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const formService = {
  add_new: (form_id, formData, serviceId, token) => {
    return https.post(
      `${API_ROUTES.FORM.ADD_NEW}/${form_id}/${serviceId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  update: (form_id, formData, token) => {
    return https.put(`${API_ROUTES.FORM.UPDATE}/${form_id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
